import { Tabs, TabsProps } from "@ofqual/portal-components/components/Tabs";
import {
  Switch,
  Route,
  useHistory,
  useRouteMatch,
  useParams,
} from "react-router-dom";

type NavigatingTabsTab = TabsProps["tabs"][0] & {
  content: React.ReactNode;
};

type NavigatingTabsTabOrFalsy =
  | NavigatingTabsTab
  | null
  | undefined
  | false
  | 0;

type NavigatingTabsProps = {
  tabs: NavigatingTabsTabOrFalsy[];
  dataTest: TabsProps["dataTest"];
};

export const NavigatingTabs: React.FC<NavigatingTabsProps> = ({ tabs }) => {
  const { push } = useHistory();
  const { url, path } = useRouteMatch();
  const { tabId } = useParams<{ tabId?: string }>();

  const realTabs: NavigatingTabsTab[] = tabs
    .filter((tab) => !!tab)
    .map((tab) => tab as NavigatingTabsTab);

  const routeOrderedTabs = [...realTabs].sort((a, b) => (a.id < b.id ? 1 : -1));

  return (
    <>
      <Tabs
        dataTest="orgs-main-tabs"
        currentTabId={tabId || ""}
        tabs={realTabs}
        onTabChange={(destinationTabId) => {
          const rootUrl =
            tabId === undefined
              ? url // if we are on the root tab then the url is the root
              : url.substring(0, url.length - tabId.length - 1); // otherwise get the root from taking the tabId away from the url

          // if we are navigating to a tab (destinationTabId is something) then add it to the root
          //  otherwise just go to the root (destinationTabId is empty)
          const destination = destinationTabId
            ? `${rootUrl}/${destinationTabId}`
            : rootUrl;
          push(destination);
        }}
      ></Tabs>
      <Switch>
        {routeOrderedTabs.map((tab) => (
          <Route key={tab.id} path={`${path}/${tab.id || ""}`}>
            {tab.content}
          </Route>
        ))}
      </Switch>
    </>
  );
};
